<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-hover v-slot:default="{ hover }">
        <v-btn icon small @click="$emit('click')" class="delete-btn" v-on="on">
          <v-icon small :color="hover ? 'blue lighten-1' : 'grey'">
            {{active ? 'fas fa-chevron-up' : 'fas fa-chevron-down'}}
          </v-icon>
        </v-btn>
      </v-hover>
    </template>
    <span>{{active ? 'Skrij' : 'Prikaži'}} vsebino</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    active: {
      required: true,
      type: Boolean
    }
  }
}
</script>
